import NeverKnowinglyUndersoldComponent from './NeverKnowinglyUndersoldComponent';
import Analytics from 'helpers/analytics/analytics';
import {AnalyticsEventType} from 'helpers/analytics/AnalyticsEventType'

export default class BoughtInShopErrorMessage extends NeverKnowinglyUndersoldComponent {
  constructor() {
    super(document.querySelector('#bought-in-shop-msg'));
  }

  render(state) {
    if (state.purchasedInAJohnLewisShop) {
      this.show();
      Analytics.addAndPublish('this form is only for online purchases', AnalyticsEventType.DATA_VALIDATION_ERROR);
    } else {
      this.hide();
    }
  }
}
